import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React, { useMemo, useCallback } from 'react';
import { DateTime } from 'luxon';
import usePickerInputValue from './usePickerInputValue.js';
import BaseDateTimePicker from './base/BaseDateTimePicker.js';

var _excluded = ["value", "onChange", "minDateTime", "maxDateTime", "slotProps"];
var dateTests = [{
  format: "yyyy-MM-dd'T'HH:mm",
  regex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/
}, {
  format: "yyyy-MM-dd'T'HH:mm:ss",
  regex: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
}];
var dateFormat = "yyyy-MM-dd'T'HH:mm:ss";

var stringToLocalDateTime = function stringToLocalDateTime(v) {
  if (!v) return null;
  var dateTest = dateTests.find(function (t) {
    return t.regex.test(v);
  });

  if (!dateTest) {
    // Remove single quotes from formats to make them more readable in the
    // error message. e.g. YYYY-MM-DD'T'HH:mm:ss -> YYYY-MM-DDTHH:mm:ss
    var validFormats = dateTests.map(function (t) {
      return t.format.replaceAll("'", "");
    });
    console.error("DateTimeLocal only accepts string value '".concat(validFormats.join(" or "), "'"));
    return null;
  }

  return DateTime.fromFormat(v, dateTest.format);
};

var localDateTimeToString = function localDateTimeToString(v) {
  return v.toFormat(dateFormat);
};

var DATE_TIME_LOCAL_FORMAT = dateFormat;

/**
 * Date and time field for local dates (local time to the user)
 */
var DateTimeLocal = function DateTimeLocal(_ref) {
  var _bounds$min, _bounds$max;

  var value = _ref.value,
      onChange = _ref.onChange,
      minDateTime = _ref.minDateTime,
      maxDateTime = _ref.maxDateTime,
      slotProps = _ref.slotProps,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var pickerValue = useMemo(function () {
    if (!value) return null;
    return stringToLocalDateTime(value);
  }, [value]);

  var _usePickerInputValue = usePickerInputValue(pickerValue),
      _usePickerInputValue2 = _slicedToArray(_usePickerInputValue, 2),
      inputValue = _usePickerInputValue2[0],
      setInputValue = _usePickerInputValue2[1];

  var pickerChange = useCallback(function (v, _ref2) {
    var validationError = _ref2.validationError;
    setInputValue(v);
    if (!onChange) return;

    if (!v || !v.isValid || !!validationError) {
      onChange(null);
      return;
    }

    onChange(localDateTimeToString(v));
  }, [onChange]);
  var bounds = useMemo(function () {
    return {
      min: typeof minDateTime === "string" ? stringToLocalDateTime(minDateTime) : minDateTime,
      max: typeof maxDateTime === "string" ? stringToLocalDateTime(maxDateTime) : maxDateTime
    };
  }, [minDateTime, maxDateTime]);
  var textFieldProps = slotProps === null || slotProps === void 0 ? void 0 : slotProps.textField;
  return /*#__PURE__*/React.createElement(BaseDateTimePicker, _extends({}, otherProps, {
    value: inputValue,
    onChange: pickerChange,
    minDateTime: (_bounds$min = bounds.min) !== null && _bounds$min !== void 0 ? _bounds$min : undefined,
    maxDateTime: (_bounds$max = bounds.max) !== null && _bounds$max !== void 0 ? _bounds$max : undefined,
    slotProps: _objectSpread2(_objectSpread2({}, slotProps), {}, {
      textField: _objectSpread2(_objectSpread2({}, textFieldProps), {}, {
        onBlur: function onBlur(e) {
          if (inputValue && !pickerValue) setInputValue(null);
          if (textFieldProps !== null && textFieldProps !== void 0 && textFieldProps.onBlur) textFieldProps.onBlur(e);
        }
      })
    })
  }));
};

DateTimeLocal.propTypes = {
  value: propTypes.oneOfType([propTypes.string, propTypes.oneOf([null])]),
  onChange: propTypes.func,
  minDateTime: propTypes.oneOfType([propTypes.any, propTypes.string, propTypes.oneOf([null])]),
  maxDateTime: propTypes.oneOfType([propTypes.any, propTypes.string, propTypes.oneOf([null])])
};
DateTimeLocal.defaultProps = {
  ampm: false,
  format: "dd/MM/yyyy HH:mm"
};
var DateTimeLocal$1 = DateTimeLocal;

export { DATE_TIME_LOCAL_FORMAT, DateTimeLocal$1 as default };
